import { display } from "@mui/system";
import { useEffect, useState } from "react";
import AddYearsPopUp from "./AddyearsPopUp";
import "./table.css";
import axios from "axios";
import { IP } from "../../../baseUrlAndConfig";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  Select,
  Stack,
  FormControl,
  InputLabel,
} from "@mui/material";
import { ValidateAuth } from "../../../AuthToken";
import { getCookie } from "../../../Cookies";
import styled from "@emotion/styled";
import HrTopNavbar from "../../Sidebar/HrTopNavbar";
import { useNavigate } from "react-router";
import DeletePopUpForDI from "./deletePop";

const Item = styled(Paper)(({ theme }) => ({
  background: "#FFF",
  textAlign: "center",
  borderRadius: "20px",
}));

export default function Retention({
  overallgender,
  setOverallgender,
  overAllFlag,
  companyId,
}) {
  const [list, setList] = useState([]);

  const [openLessonPopUp, setopenLessonPopUp] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [genderList, setgenderList] = useState([
    { name: "Junior" },
    { name: "MidLevel" },
    { name: "Senior" },
  ]);
  const [openpopUpForAddYears, setOpenpopUpForAddYears] = useState(false);

  const [
    OverallGenderRepresentationState,
    setOverallGenderRepresentationState,
  ] = useState([]);

  const [bussinessvertical, setBussinessvertical] = useState([]);
  const [genderbyRegionStates, setgenderbyRegionStates] = useState([]);
  const [genderbyBusinessVerticalstate, setGenderbyBusinessVerticalstate] =
    useState([]);

  const navigate = useNavigate();
  const goToHome = () => navigate("/");
  useEffect(() => {
    // ValidateAuth();
    // let newobj = JSON.parse(getCookie("roles"));
    // if (!newobj.HRDI?.includes(getCookie("ROLE"))) {
    //   goToHome();
    //   return <></>;
    // }
  }, []);

  const addGenderbyBusinessVertical = (ind) => {
    if (!list[ind].year) {
      alert("select year first");
      return;
    }

    let dataregionf = JSON.stringify({
      year: list[ind].year,

      date: Date.now(),
      businessVertical: "",

      Junior: { male: 0, female: 0, nonBinary: 0 },
      MidLevel: { male: 0, female: 0, nonBinary: 0 },
      Senior: { male: 0, female: 0, nonBinary: 0 },
    });

    let configregiony = {
      method: "post",

      url: `${IP}/retention?companyId=${companyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: dataregionf,
    };

    axios(configregiony)
      .then((res) => {
        // let recrut = res.data;
        // let newobj = {};
        // for (let i = 0; i < recrut.length; i++) {
        //   newobj[recrut[i]?.year] = "af";
        // }
        // for (let key in newobj) {
        //   setList((prev) => prev.concat({ year: key }));
        // }
        // setGenderbyBusinessVerticalstate(res.data);
        //console.log(res.data);
      })
      .catch((er) => {
        console.log(er);
      });
    setGenderbyBusinessVerticalstate((prev) =>
      prev.concat({
        year: list[ind].year,

        date: Date.now(),
        businessVertical: "",

        Junior: { male: 0, female: 0, nonBinary: 0 },
        MidLevel: { male: 0, female: 0, nonBinary: 0 },
        Senior: { male: 0, female: 0, nonBinary: 0 },
      })
    );
  };
  useEffect(() => {
    //setgenderbyRegionStates(ex);

    let configvr = {
      method: "get",

      url: `${IP}/bussinessVertical?companyId=${companyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "data",
    };
    axios(configvr).then((res) => {
      setBussinessvertical(res.data);
    });

    let dataregionf = JSON.stringify(genderbyRegionStates);

    let configregiony = {
      method: "get",

      url: `${IP}/retention?companyId=${companyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: "dataregion",
    };

    axios(configregiony)
      .then((res) => {
        let recrut = res.data;
        let newobj = {};
        for (let i = 0; i < recrut.length; i++) {
          newobj[recrut[i]?.year] = "af";
        }
        for (let key in newobj) {
          setList((prev) => prev.concat({ year: key }));
        }
        setGenderbyBusinessVerticalstate(res.data);
        //console.log(res.data);
      })
      .catch((er) => {
        console.log(er);
      });
  }, []);

  useEffect(() => {
    let dataregionf = JSON.stringify(genderbyBusinessVerticalstate);

    let configregiony = {
      method: "patch",

      url: `${IP}/retention?companyId=${companyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: dataregionf,
    };

    if (genderbyBusinessVerticalstate?.length > 0) {
      axios(configregiony)
        .then((res) => {})
        .catch((er) => {
          console.log(er);
        });
    }

    setOverallgender((prev) => ({
      ...prev,

      retentionbusinessvertical: genderbyBusinessVerticalstate
        ? genderbyBusinessVerticalstate
        : [],
    }));
    // setgenderbyRegionStates(ex);
  }, [genderbyBusinessVerticalstate]);

  useEffect(() => {
    // console.log(overallgender);
    // let ls = overallgender.OverallGenderRepresentationState
    //   ? overallgender.OverallGenderRepresentationState
    //   : [];

    // setList([]);

    // for (let i = 0; i < ls.length; i++) {
    //   setList((prev) => prev.concat({ year: ls[i]?.year }));
    //   // setListbuver((prev) => prev.concat({ year: ls[i]?.year }));
    // }

    let recrut = overallgender.retentionbusinessvertical
      ? overallgender.retentionbusinessvertical
      : [];
    let newobj = {};
    for (let i = 0; i < recrut.length; i++) {
      newobj[recrut[i]?.year] = "af";
    }
    for (let key in newobj) {
      setList((prev) => prev.concat({ year: key }));
    }

    setOverallGenderRepresentationState(
      overallgender.OverallGenderRepresentationState
        ? overallgender.OverallGenderRepresentationState
        : []
    );
    setGenderbyBusinessVerticalstate(
      overallgender.retentionbusinessvertical
        ? overallgender.retentionbusinessvertical
        : []
    );

    // setgenderbyRegionStates(ex);
  }, [overAllFlag]);

  const openPopUpForAddYears = () => {
    setOpenpopUpForAddYears(true);
  };
  const addYearsFunPopUp = (Years) => {
    console.log(Years);

    setOverallGenderRepresentationState((prev) =>
      prev.concat({
        year: Years,
        male: 0,
        female: 0,
        nonBinary: 0,
      })
    );
    setOpenpopUpForAddYears(false);
  };
  console.log(genderbyRegionStates);
  //console.log(Object.keys(curvalue)[0])

  // useEffect(() => {}, []);
  const deleteYearData = (input) => {
    let temparr = genderbyBusinessVerticalstate.filter(
      (ele) => ele.date != input.date
    );
    let dataregionf = JSON.stringify(temparr);

    let configregiony = {
      method: "patch",

      url: `${IP}/retention?companyId=${companyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie("bearer")}`,
      },
      data: dataregionf,
    };

    if (genderbyBusinessVerticalstate?.length > 0) {
      axios(configregiony)
        .then((res) => {
          setGenderbyBusinessVerticalstate(temparr);
        })
        .catch((er) => {
          console.log(er);
        });
    }
  };
  const deleteFunctionCallFromUi = (data, type) => {
    // console.log(data);
    let newobj = { ...data, type };
    setDeleteId(newobj);
    setopenLessonPopUp(true);
  };
  const delfunction = (name) => {
    if (name.type == "retention") {
      deleteYearData(name);
    }
  };

   const checkAlreadyVertical =(paramArray,vertical,year)=>{

    // genderbyBusinessVerticalstate?.map((_,idx)=>{

    // })
    const vertArr = [];
    for(let i=0;i<paramArray?.length;i++){
      if(paramArray[i].year == year){
        vertArr.push(paramArray[i].businessVertical);
      }
    }
    const outputArr = [];
    bussinessvertical?.map((_,idx)=>{
      if(!vertArr.includes(_)){
        outputArr.push(_);
      }
    })
    outputArr.push(vertical)

    return outputArr;


    
  }


  return (
    <Box>
      <Box
        sx={{
          position: "sticky",
          top: "0",
          backgroundColor: "#F3F1FF",
          zIndex: "2",

          paddingTop: "20px",
        }}
      >
        {/* str={{ ml: "2vw", py: "10px", w: "98%" }} */}
        <HrTopNavbar title={"Retention"}>
          {/* <Box
          sx={{
            color: "#6846C7",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: 600,
            fontFamily: "Manrope",
          }}
        >
          Save & Exit
        </Box> */}
        </HrTopNavbar>
      </Box>
      <AddYearsPopUp
        open={openpopUpForAddYears}
        onClose={() => setOpenpopUpForAddYears(false)}
        delfun={(topic) => {
          addYearsFunPopUp(topic);
        }}
      />
      <DeletePopUpForDI
        open={openLessonPopUp}
        onClose={() => setopenLessonPopUp(false)}
        delfun={(topic) => {
          delfunction(topic);
        }}
        topicId={deleteId}
        itemName={"Lesson"}
      />
      <Box
        className="tableHedingNamefontFamily"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          mt: "24px",
          ml: "24px",
        }}
      >
        <Box
          sx={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            backgroundColor: "#E5E0F9",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          1
        </Box>{" "}
        Number of exits
      </Box>

      <Box
        className="tablebgColorForHr"
        sx={{ width: "97%", padding: "0px 20px", mt: "15px", ml: 3 }}
      >
        {list.map((listele, ind) => (
          <Box sx={{ mb: "40px" }}>
            <Box style={{ display: "flex" }}>
              <Box>
                {" "}
                <Select
                  className="select-year"
                  name="se"
                  sx={{ height: "55px" }}
                  onChange={(e) => {
                    // let data = list;
                    // data[ind] = { year: e.target.value };
                    // setList(data);

                    setList((prev) => {
                      return prev.filter((ele, inx) => {
                        if (inx == ind) {
                          ele.year = e.target.value;
                        }
                        return ele;
                      });
                    });
                    // setGenderbyBusinessVerticalyear(e.target.value);
                  }}
                  value={listele.year}
                >
                  <MenuItem value={""}>Select year</MenuItem>

                  {OverallGenderRepresentationState?.map((e) => (
                    <MenuItem value={e?.year}> {e?.year}</MenuItem>
                  ))}
                </Select>{" "}
              </Box>
            </Box>

            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              className="tableHightandSizeForThreeSections"
              sx={{ mt: "10px" }}
            >
              {genderbyBusinessVerticalstate?.map((elementList) => {
                if (elementList.year == listele.year) {
                  return (
                    <Grid item xs={6}>
                      <Item>
                        <Box className="genderbyRegionTableContent">
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "right",
                              alignItems: "right",
                              color: "#BCBCBC",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              deleteFunctionCallFromUi(
                                elementList,
                                "retention"
                              );
                            }}
                          >
                            {/* <DeleteIcon /> */}

                            <svg
                              width="11"
                              height="11"
                              viewBox="0 0 11 11"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.43 0.244723C10.1145 -0.0707873 9.60485 -0.0707873 9.28934 0.244723L5.33333 4.19264L1.37732 0.236633C1.06181 -0.0788775 0.552143 -0.0788775 0.236633 0.236633C-0.0788775 0.552143 -0.0788775 1.06181 0.236633 1.37732L4.19264 5.33333L0.236633 9.28934C-0.0788775 9.60485 -0.0788775 10.1145 0.236633 10.43C0.552143 10.7455 1.06181 10.7455 1.37732 10.43L5.33333 6.47402L9.28934 10.43C9.60485 10.7455 10.1145 10.7455 10.43 10.43C10.7455 10.1145 10.7455 9.60485 10.43 9.28934L6.47402 5.33333L10.43 1.37732C10.7375 1.0699 10.7375 0.552143 10.43 0.244723Z"
                                fill="#707EAE"
                              />
                            </svg>
                          </Box>
                          <Box style={{ margin: "20px" }}>
                            <Box>
                              <Box>
                                {" "}
                                <FormControl>
                                  <InputLabel id="demo-simple-select-label79">
                                    Select business vertical
                                  </InputLabel>
                                  <Select
                                    label="Select business vertical"
                                    labelId="demo-simple-select-label79"
                                    id="demo-simple-select"
                                    MenuProps={{
                                      sx: {
                                        maxHeight: "250px",
                                        maxWidth: "300px",
                                      },
                                    }}
                                    sx={{
                                      width: "260px",
                                      height: "55px",
                                      fontSize: "18px",
                                      backgroundColor: "transparent",
                                    }}
                                    value={elementList?.businessVertical}
                                    onChange={(e) => {
                                      setGenderbyBusinessVerticalstate(
                                        (prev) => {
                                          return prev.filter(
                                            (curvalue, idx) => {
                                              if (
                                                curvalue.year == listele.year &&
                                                curvalue.date ==
                                                  elementList.date
                                              ) {
                                                curvalue.businessVertical =
                                                  e.target.value;
                                              }
                                              console.log(curvalue);
                                              return curvalue;
                                            }
                                          );
                                        }
                                      );
                                    }}
                                  >
                                    {checkAlreadyVertical(genderbyBusinessVerticalstate,elementList?.businessVertical,listele.year).map((el)=>{
                                      return(<MenuItem value={el}>{el}</MenuItem>)
                                    })}
                                    {/* {bussinessvertical?.map((el) => (
                                      <MenuItem value={el}>{el}</MenuItem>
                                    ))} */}
                                  </Select>
                                </FormControl>
                              </Box>
                            </Box>
                          </Box>

                          <Box
                            style={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr 1fr",
                              gridGap: "20px",
                            }}
                          >
                            {genderList?.map((el) => (
                              <Box
                                style={{
                                  marginTop: "10px",
                                  textAlign: "center",
                                }}
                              >
                                <Box>
                                  <Box> {el.name} </Box>
                                </Box>
                                <Box className="genderBox">
                                  <Box className="genderbyRegionInputBoxLabel">
                                    {" "}
                                    Male{" "}
                                  </Box>
                                  <Box>
                                    {" "}
                                    <input
                                      min="0"
                                      type="Number"
                                      className="genderbyRegionInputBox"
                                      value={elementList[el.name]?.male}
                                      onChange={(e) => {
                                        setGenderbyBusinessVerticalstate(
                                          (prev) => {
                                            return prev.filter(
                                              (curvalue, idx) => {
                                                if (
                                                  curvalue.year ==
                                                    listele.year &&
                                                  curvalue.date ==
                                                    elementList.date
                                                ) {
                                                  curvalue[el.name].male =
                                                    Number(e.target.value);
                                                }
                                                console.log(curvalue);
                                                return curvalue;
                                              }
                                            );
                                          }
                                        );
                                      }}
                                    />{" "}
                                  </Box>
                                </Box>
                                <Box className="genderBox">
                                  <Box className="genderbyRegionInputBoxLabel">
                                    {" "}
                                    Female{" "}
                                  </Box>
                                  <Box>
                                    {" "}
                                    <input
                                      min="0"
                                      type="Number"
                                      className="genderbyRegionInputBox"
                                      value={elementList[el.name]?.female}
                                      onChange={(e) => {
                                        setGenderbyBusinessVerticalstate(
                                          (prev) => {
                                            return prev.filter(
                                              (curvalue, idx) => {
                                                if (
                                                  curvalue.year ==
                                                    listele.year &&
                                                  curvalue.date ==
                                                    elementList.date
                                                ) {
                                                  curvalue[el.name].female =
                                                    Number(e.target.value);
                                                }
                                                // console.log(curvalue);
                                                return curvalue;
                                              }
                                            );
                                          }
                                        );
                                      }}
                                    />{" "}
                                  </Box>
                                </Box>
                                <Box className="genderBox">
                                  <Box className="genderbyRegionInputBoxLabel">
                                    {" "}
                                    Non-binary{" "}
                                  </Box>
                                  <Box>
                                    {" "}
                                    <input
                                      min="0"
                                      type="Number"
                                      className="genderbyRegionInputBox"
                                      value={elementList[el.name]?.nonBinary}
                                      onChange={(e) => {
                                        setGenderbyBusinessVerticalstate(
                                          (prev) => {
                                            return prev.filter(
                                              (curvalue, idx) => {
                                                if (
                                                  curvalue.year ==
                                                    listele.year &&
                                                  curvalue.date ==
                                                    elementList.date
                                                ) {
                                                  curvalue[el.name].nonBinary =
                                                    Number(e.target.value);
                                                }
                                                console.log(curvalue);
                                                return curvalue;
                                              }
                                            );
                                          }
                                        );
                                      }}
                                    />{" "}
                                  </Box>
                                </Box>
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Item>
                    </Grid>
                  );
                }
              })}
            </Grid>
            <Box
              className="addYearsbutton"
              onClick={() => {
                addGenderbyBusinessVertical(ind);
              }}
            >
              {" "}
              Add business vertical
            </Box>
          </Box>
        ))}
        <Box
          className="addYearsbutton"
          onClick={() => {
            setList((prev) => prev.concat({ year: "" }));
          }}
          sx={{cursor:'pointer'}}

        >
          {" "}
          Add year
        </Box>
      </Box>
    </Box>
  );
}
